import { SituacaoUpload, TipoDocumentoParceiroCertificacao } from 'src/tipos'

import { UploadDocumentos } from '../tipos'

export const RelacaoDocumentosParceiroCertificacao = new Array<UploadDocumentos>(
  {
    id: 1,
    tipo: TipoDocumentoParceiroCertificacao.Logo,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 1,
    obrigatorio: true,
    editarAprovado: true
  } as UploadDocumentos
)
